import React, { useState } from "react";
import SideMenuData from "./side-menu-data";
import { Grid, Badge, IconButton } from "@mui/material";
import "./side-menu.css";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Menu from "@mui/material/Menu";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "./../../../assets/images/logo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import ForumIcon from "@mui/icons-material/Forum";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import CampaignIcon from "@mui/icons-material/Campaign";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import GroupIcon from "@mui/icons-material/Group";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { Button } from "@mui/material";
import ProfileImg from "./../../../assets/images/ProfileImage.png";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import BadgeIcon from "@mui/icons-material/Badge";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
import HistoryIcon from "@mui/icons-material/History";
import { IoLogOutSharp } from "react-icons/io5";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation, useNavigate } from "react-router-dom";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PagesIcon from "@mui/icons-material/Pages";
import { BiChevronDown } from "react-icons/bi";
import SettingsIcon from "@mui/icons-material/Settings";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TaskIcon from "@mui/icons-material/Task";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import Model from "./../model";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import GroupsIcon from "@mui/icons-material/Groups";
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
    backgroundColor: "white",
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  backgroundColor: "white",
  border: "1px solid #A6A6A6",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(3),
    width: "500px",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "450px",
    },
  },
}));

export const SideMenu = (props) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [popupOpen, setPopupOpen] = React.useState(false);
  let [pagesShow, setPagesShow] = React.useState(false);
  const location = useLocation();
  let CurrentPagePath = location.pathname;
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileView = useMediaQuery(theme.breakpoints.down("lg"));

  let NotificationData = [
    {
      name: "Samantha aryton",
      tag: "Complate",
      message: "your Lorem ipsum dolor sit a...",
    },
    {
      name: "Nataliya law",
      tag: "Congratulate",
      message: "Lorem ipsum dolor sit a...",
      title: "purchase your ",
    },
    {
      name: "Samantha aryton",
      tag: "Complate",
      message: "your Lorem ipsum dolor sit a...",
    },
    {
      name: "Nataliya law",
      tag: "Congratulate",
      message: "Lorem ipsum dolor sit a...",
      title: "purchase your ",
    },
  ];
  return (
    <>
      <div>
        <Grid container>
          <Grid item xs={12} md={2}>
            <SideMenuData />
          </Grid>
          <Grid item xs={12} lg={10}>
            <div className="tutot-right-side-container">
              <div className="tutor-dashboard-page-header-container">
                <div className="tutor-dashboard-page-header-content-wrapper">
                  <div>
                    {isMatch ? (
                      <div>
                        <IconButton
                          onClick={() => {
                            setIsDrawerOpen(true);
                          }}
                        >
                          <MenuIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <div> </div>
                    )}

                    <Drawer
                      anchor="left"
                      open={isDrawerOpen}
                      onClose={handleDrawerClose}
                    >
                      <div>
                        <div className="tutor-panel-sider-content-wraper">
                          <div className="drawer-header-main">
                            <img src={logo} alt="logo" width="100px" />
                            <IconButton
                              onClick={() => {
                                handleDrawerClose();
                              }}
                              className="app-bar-component-drawer-close-btn"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                          <div className="side-menu-data-list-main">
                            <ul className="side-menu-ul">
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/home"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/home");
                                  }}
                                >
                                  <HomeIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    home
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/dasboard"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/dasboard");
                                  }}
                                >
                                  <DashboardIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    dashboard
                                  </span>
                                </Button>
                              </li>

                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/profile"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    ("/profile");
                                  }}
                                >
                                  <PersonIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    profile
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/my-classes" ||
                                    CurrentPagePath === "/my-classes/create" ||
                                    CurrentPagePath === "/my-classes/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/my-classes");
                                  }}
                                >
                                  <BookIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my classes
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/class-history" ||
                                    CurrentPagePath === "/class-history/view" ||
                                    CurrentPagePath ===
                                      "/class-history/analytics"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/class-history");
                                  }}
                                >
                                  <HistoryIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Class History
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/online-classes" ||
                                    CurrentPagePath ===
                                      "/online-class/analytics" ||
                                    CurrentPagePath === "/online-class/view" ||
                                    CurrentPagePath === "/online-class/create"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/online-classes");
                                  }}
                                >
                                  <BookOnlineIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    online classes
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/add-staff" ||
                                    CurrentPagePath ===
                                      "/add-staff/analytics" ||
                                    CurrentPagePath === "/add-staff/add"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/add-staff");
                                  }}
                                >
                                  <GroupIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Add Staff
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/tutor" ||
                                    CurrentPagePath === "/tutor/analytics" ||
                                    CurrentPagePath === "/tutor/add"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/tutor");
                                  }}
                                >
                                  <BadgeIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Tutor
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/add-student" ||
                                    CurrentPagePath ===
                                      "/add-student/analytics" ||
                                    CurrentPagePath === "/add-student/add"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/add-student");
                                  }}
                                >
                                  <MenuBookIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Add student
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/organize-event" ||
                                    CurrentPagePath ===
                                      "/organize-event/analytics" ||
                                    CurrentPagePath ===
                                      "/organize-event/view" ||
                                    CurrentPagePath === "/organize-event/create"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/organize-event");
                                  }}
                                >
                                  <EventNoteIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Organize event
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/organize-trip" ||
                                    CurrentPagePath ===
                                      "/organize-trip/analytics" ||
                                    CurrentPagePath === "/organize-trip/view" ||
                                    CurrentPagePath ===
                                      "/organize-trip/create" ||
                                    CurrentPagePath === "/organize-trip/book"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/organize-trip");
                                  }}
                                >
                                  <ModeOfTravelIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Organize trip
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/purchases-product" ||
                                    CurrentPagePath ===
                                      "/purchases-product/view" ||
                                    CurrentPagePath ===
                                      "/purchases-product/my-cart" ||
                                    CurrentPagePath ===
                                      "/purchases-product/message"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/purchases-product");
                                  }}
                                >
                                  <ShoppingCartIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Purchases Product
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/purchases-history" ||
                                    CurrentPagePath === "/purchases-history/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/purchases-history");
                                  }}
                                >
                                  <ManageHistoryIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Purchases History
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/chat"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/chat");
                                  }}
                                >
                                  <ForumIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    chat inbox
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/rating" ||
                                    CurrentPagePath === "/rating/view" ||
                                    CurrentPagePath === "/rating/analytics"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/rating");
                                  }}
                                >
                                  <StarHalfIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    ratings
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/my-promotions" ||
                                    CurrentPagePath === "/my-promotions/create"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/my-promotions");
                                  }}
                                >
                                  <CampaignIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my promotions
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/notifications" ||
                                    CurrentPagePath === "/notification/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/notifications");
                                  }}
                                >
                                  <NotificationsActiveIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    notifications
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/my-wallet"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/my-wallet");
                                  }}
                                >
                                  <AccountBalanceWalletIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    my wallet
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/dispute" ||
                                    CurrentPagePath === "/dispute/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/dispute");
                                  }}
                                >
                                  <PsychologyIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    dispute
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/invoice" ||
                                    CurrentPagePath === "/invoice/create" ||
                                    CurrentPagePath === "/invoice/view" ||
                                    CurrentPagePath === "/invoice/preview"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/invoice");
                                  }}
                                >
                                  <PriceChangeIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    invoice
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/time-table"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/time-table");
                                  }}
                                >
                                  <CalendarMonthIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    time table
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/attendance"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/attendance");
                                  }}
                                >
                                  <GroupsIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    attendance
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/salary-requests"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/salary-requests");
                                  }}
                                >
                                  <LocalAtmIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    salary request
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/leave-request" ||
                                    CurrentPagePath === "/leave-request/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/leave-request");
                                  }}
                                >
                                  <LiveHelpIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    leave request
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/assignment" ||
                                    CurrentPagePath === "/assignment/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/assignment");
                                  }}
                                >
                                  <AssignmentIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Assignment
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/submited-task" ||
                                    CurrentPagePath === "/submited-task/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/submited-task");
                                  }}
                                >
                                  <TaskIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    Submited task
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/result" ||
                                    CurrentPagePath === "/result/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/result");
                                  }}
                                >
                                  <FactCheckIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    result
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/transaction-history" ||
                                    CurrentPagePath === "/transaction-history/view"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/transaction-history");
                                  }}
                                >
                                  <PointOfSaleIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    transaction history
                                  </span>
                                </Button>
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/banner" ||
                                    CurrentPagePath ===
                                      "/add-most-populer-tutors" ||
                                    CurrentPagePath === "/about-us" ||
                                    CurrentPagePath ===
                                      "/add-populer-courses" ||
                                    CurrentPagePath ===
                                      "/add-our-student-says" ||
                                    CurrentPagePath ===
                                      "/add-upcomming-events" ||
                                    CurrentPagePath === "/add-our-latest-update"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => setPagesShow(!pagesShow)}
                                >
                                  <PagesIcon className="side-menu-icon" />
                                  <div className="side-menu-more-pages">
                                    <span className="side-menu-page-title">
                                      website pages
                                    </span>
                                    <BiChevronDown
                                      className="side-menu-icon"
                                      size={30}
                                    />
                                  </div>
                                </Button>
                                {pagesShow && (
                                  <div className="drawer-website-pages-main">
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath === "/banner"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/banner");
                                      }}
                                    >
                                      Banner
                                    </Button>
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath ===
                                        "/add-populer-courses"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/add-populer-courses");
                                      }}
                                    >
                                      Populer Courses
                                    </Button>
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath ===
                                        "/add-most-populer-tutors"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/add-most-populer-tutors");
                                      }}
                                    >
                                      most populer tutors
                                    </Button>
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath === "/about-us"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/about-us");
                                      }}
                                    >
                                      about us
                                    </Button>
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath ===
                                        "/add-our-student-says"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/add-our-student-says");
                                      }}
                                    >
                                      Our Student says
                                    </Button>{" "}
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath ===
                                        "/add-upcomming-events"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/add-upcomming-events");
                                      }}
                                    >
                                      Upcomming Events
                                    </Button>
                                    <Button
                                      variant="text"
                                      className={
                                        CurrentPagePath ===
                                        "/add-our-latest-update"
                                          ? "side-menu-active-page"
                                          : "side-menu-page"
                                      }
                                      onClick={() => {
                                        navigate("/add-our-latest-update");
                                      }}
                                    >
                                      Our latest update
                                    </Button>
                                  </div>
                                )}
                              </li>
                              <li className="tutor-panel-sider-list-item">
                                <Button
                                  variant="text"
                                  className={
                                    CurrentPagePath === "/settings" ||
                                    CurrentPagePath === "/settings/invoice" ||
                                    CurrentPagePath === "/settings/tc"
                                      ? "side-menu-active-page"
                                      : "side-menu-page"
                                  }
                                  onClick={() => {
                                    navigate("/settings");
                                  }}
                                >
                                  <SettingsIcon className="side-menu-icon" />
                                  <span className="side-menu-page-title">
                                    settings
                                  </span>
                                </Button>
                              </li>
                              <br />
                            </ul>
                          </div>
                          <div className="first-tutor-panel-sider-log-out-container">
                            <Button
                              variant="text"
                              className="logout-button"
                              onClick={() => {
                                navigate("/");
                              }}
                            >
                              <span>Logout</span>
                              <IoLogOutSharp className="side-menu-icon" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Drawer>
                  </div>

                  <div className="side-menu-header">
                    <div>
                      {isMobileView ? (
                        <div> </div>
                      ) : (
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                          />
                        </Search>
                      )}
                    </div>
                    <div className="tutor-dashboard-page-header-content-wrapper-profile-logo">
                      <div>
                        {props.purchseIcon && (
                          <IconButton
                            id="basic-button"
                            aria-controls={open ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            onClick={() =>
                              navigate("/purchases-product/my-cart")
                            }
                          >
                            <Badge
                              badgeContent={4}
                              overlap="circular"
                              color="error"
                              className="badge-color"
                            >
                              <ShoppingCartIcon
                                style={{ color: "#663399", fontSize: "30px" }}
                              />
                            </Badge>
                          </IconButton>
                        )}
                        <IconButton
                          id="basic-button"
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                        >
                          <Badge
                            badgeContent={4}
                            overlap="circular"
                            color="error"
                            className="badge-color"
                          >
                            <NotificationsIcon
                              style={{ color: "#663399", fontSize: "30px" }}
                            />
                          </Badge>
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <div className="first-tutor-doashboard-notification-wraper">
                            <Button
                              variant="text"
                              className="notification-clear-all-button"
                            >
                              <CloseIcon />
                              <p>Clear All</p>
                            </Button>
                            <div className="side-menu-notification-main">
                              {NotificationData.map(
                                (notificationValue, notificationIndex) => {
                                  return (
                                    <div
                                      key={notificationIndex}
                                      onClick={() => setPopupOpen(true)}
                                    >
                                      {notificationValue.tag === "Complate" ? (
                                        <div className="side-menu-notification-card">
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.name}{" "}
                                          </span>
                                          <span className="side-menu-notification-title">
                                            {notificationValue.tag}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.message}
                                          </span>
                                          <p className="side-menu-notification-date">
                                            JAN 5, 2022
                                          </p>
                                        </div>
                                      ) : (
                                        <div
                                          className="side-menu-notification-card"
                                          onClick={() => setPopupOpen(true)}
                                        >
                                          <span className="side-menu-notification-title">
                                            {notificationValue.tag}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.name}{" "}
                                          </span>
                                          <span className="side-menu-notification-title">
                                            {notificationValue.title}{" "}
                                          </span>
                                          <span className="side-menu-notification-heading">
                                            {notificationValue.message}
                                          </span>
                                          <p className="side-menu-notification-date">
                                            JAN 5, 2022
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </Menu>
                      </div>
                      <p className="side-menu-header-username">Gmits classes</p>
                      <img
                        src={ProfileImg}
                        alt="Profile"
                        className="side-menu-header-profile-image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  props.chat
                    ? "side-menu-children-chat-data"
                    : "side-menu-children-data"
                }
              >
                {props.children}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <Model
        modelTitle="Notification"
        width="md"
        onClose={() => setPopupOpen(false)}
        open={popupOpen}
        buttonHide={true}
      >
        <div>
          <div className="notification-model-header">
            <div>
              <span className="notification-model-username">
                Samantha aryton
              </span>
              <span className="notification-model-complete-title">
                Complate
              </span>
              <span className="notification-model-username">
                your Lorem ipsum dolor sit
              </span>
            </div>
            <p className="notification-model-date">JAN 5, 2022</p>
          </div>
          <p className="notification-model-description">
            Curabitur tincidunt eros in est aliquet, vel congue ex egestas.
            <br />
            <br />
            Nullam id nibh vitae dui euismod cursus vitae elementum tortor.
            Fusce congue faucibus nulla vel semper. Donec ac interdum ipsum.
            <br />
            <br />
            Proin cursus sem mi, sit amet tempor diam pulvinar cursus. Ut ac
            tempus risus. In ac metus ac metus mattis fermentum id in dolor.
            <br />
            <br />
            Fusce sollicitudin vitae ante in finibus. Maecenas gravida nibh et
            nulla fringilla consequat sit amet vehicula massa. Aliquam in tellus
            pharetra, ultrices est in, sagittis elit.
            <br />
            <br /> Etiam eget diam vel nulla congue viverra. Nullam et iaculis
            nisi, sit amet mollis risus.
          </p>
        </div>
      </Model>
    </>
  );
};

export default SideMenu;
